<main class="main" id="top">
    <div class="container-fluid">
        <div class="col-12 text-center my-2">
            <div class="fs-1">Premium Features</div>


        </div>

        <div class="table-responsive mt-3 p-3">
            <table class="table table-dark">
                <thead class="text-center fs--1">
                    <tr>
                        <th scope="col" style="width:10%">#</th>
                        <th scope="col" style="width:50%">Features</th>
                        <th scope="col" style="width:10%">Select</th>
                        <th scope="col" style="width:30%">Price</th>
                    </tr>
                </thead>
                <tbody class="text-center fs--1">
                    <tr>
                        <td>1</td>
                        <td>Gst Billing</td>
                        <td>
                            <span style="justify-content:center;" class="d-flex form-check">
                                <input class="form-check-input" id="flexCheckDefault" type="checkbox" value="" />

                            </span>
                        </td>
                        <td>100</td>>
                    </tr>






                </tbody>

                <tfoot>
                    <tr class="text-center fs--1">
                        <th scope="col">

                        </th>
                        <th scope="col"></th>
                        <th scope="col" style="color:#00FFFF">Total</th>
                        <th scope="col" style="color:#00FFFF">-
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>

    </div>
</main>